import * as XLSX from 'xlsx'
import * as R from 'ramda'
import * as Promise from 'bluebird';
// TODO: error
export const file2ArrayBuffer = (file) => {
  return new Promise((resolve) => {
    var fileReader = new FileReader()
    fileReader.onload = (e) => {
      resolve(e.target.result) //arraybuffer
    }
    fileReader.readAsArrayBuffer(file)
  })
}
export const arrayBuffer2Binary = (arrayBuffer) => {
  return new Promise((resolve) => {
    let binary = ''
    const bytes = new Uint8Array(arrayBuffer)
    const length = bytes.byteLength
    for (var i = 0; i < length; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    resolve(binary)
  })
}
export const binary2Xlsx = (binary) => {
  return new Promise((resolve) => {
    var xlsx = XLSX.read(binary, { type: 'binary', cellDates:true, cellStyles:true })
    resolve(xlsx)
  })
}
// MEMO: 最初はプロパティhで取得していたが、ファイルによっては取れないケース（保存したアプリが違うなど）がありvに変更
export const getCellValueInSheet = (xlsxSheet, {column, row}) => {
  return R.path([column + row, 'v'], xlsxSheet)
}

export const getRowsLength = (xlsxSheet) => {
  if (R.has('!rows')(xlsxSheet)) {
    return R.length(R.path(['!rows'] ,xlsxSheet))  
  } else {
    // MEMO: xlsxによっては!rowsプロパティが存在しないケースがある
    return R.pipe(
      R.prop('!ref'),
      R.split(':'),
      R.last,
      R.replace(/[^0-9]/g, ''),
      Number
    )(xlsxSheet)
  }
}

export const getColumnsLength = (xlsxSheet) => {
  return R.length(R.path(['!cols'] ,xlsxSheet))
}

// export const getKey = (column) => {

// }

// export const getValue = (vo)

// export const getRecord = (xlsxSheet, {row}) => {
  // return R.path([column + row, 'h'], xlsxSheet)

// }